import * as Types from '../../../../gql/__generated/graphql.types';

import { SeoMetaDataFragment } from '../../../common/gql/__generated/seoMetadata.generated';
import { SeoMetaDataFragmentDoc } from '../../../common/gql/__generated/seoMetadata.generated';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { graphqlFetcher } from '@/modules/common/services/graphqlFetcher';
export type AuthorFieldsFragment = (
  { __typename?: 'BlogPostAuthor' }
  & Pick<Types.BlogPostAuthor, 'slug' | 'name' | 'role' | 'twitter' | 'pinterest' | 'threads' | 'authorPicks'>
  & { description?: Types.Maybe<(
    { __typename?: 'BlogPostAuthorDescription' }
    & Pick<Types.BlogPostAuthorDescription, 'json'>
    & { links: (
      { __typename?: 'BlogPostAuthorDescriptionLinks' }
      & { assets: (
        { __typename?: 'BlogPostAuthorDescriptionAssets' }
        & { block: Array<Types.Maybe<(
          { __typename: 'ContentfullAsset' }
          & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
          & { sys: (
            { __typename?: 'Sys' }
            & Pick<Types.Sys, 'id'>
          ) }
        )>> }
      ) }
    ) }
  )>, avatar?: Types.Maybe<(
    { __typename?: 'ContentfullAsset' }
    & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
  )> }
);

export type BlogPostAuthorQueryVariables = Types.Exact<{
  slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type BlogPostAuthorQuery = (
  { __typename?: 'Query' }
  & { blogPostAuthorCollection?: Types.Maybe<(
    { __typename?: 'BlogPostAuthorCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BlogPostAuthor' }
      & AuthorFieldsFragment
    )>> }
  )> }
);

export type BlogPostAuthorSeoQueryVariables = Types.Exact<{
  slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type BlogPostAuthorSeoQuery = (
  { __typename?: 'Query' }
  & { blogPostAuthorCollection?: Types.Maybe<(
    { __typename?: 'BlogPostAuthorCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BlogPostAuthor' }
      & { seo?: Types.Maybe<(
        { __typename?: 'SeoMetadata' }
        & SeoMetaDataFragment
      )>, avatar?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url'>
      )> }
    )>> }
  )> }
);


export const AuthorFieldsFragmentDoc = `
    fragment AuthorFields on BlogPostAuthor {
  slug
  name
  role
  twitter
  pinterest
  threads
  description {
    json
    links {
      assets {
        block {
          sys {
            id
          }
          url
          title
          width
          height
          __typename
        }
      }
    }
  }
  authorPicks
  avatar {
    url
    title
    width
    height
  }
}
    `;
export const BlogPostAuthorDocument = `
    query blogPostAuthor($slug: String) {
  blogPostAuthorCollection(limit: 1, where: {slug: $slug}) {
    items {
      ...AuthorFields
    }
  }
}
    ${AuthorFieldsFragmentDoc}`;

export const useBlogPostAuthorQuery = <
      TData = BlogPostAuthorQuery,
      TError = unknown
    >(
      variables?: BlogPostAuthorQueryVariables,
      options?: Omit<UseQueryOptions<BlogPostAuthorQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BlogPostAuthorQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BlogPostAuthorQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['blogPostAuthor'] : ['blogPostAuthor', variables],
    queryFn: graphqlFetcher<BlogPostAuthorQuery, BlogPostAuthorQueryVariables>(BlogPostAuthorDocument, variables),
    ...options
  }
    )};

useBlogPostAuthorQuery.getKey = (variables?: BlogPostAuthorQueryVariables) => variables === undefined ? ['blogPostAuthor'] : ['blogPostAuthor', variables];


useBlogPostAuthorQuery.fetcher = (variables?: BlogPostAuthorQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BlogPostAuthorQuery, BlogPostAuthorQueryVariables>(BlogPostAuthorDocument, variables, options);

export const BlogPostAuthorSeoDocument = `
    query blogPostAuthorSeo($slug: String) {
  blogPostAuthorCollection(where: {slug: $slug}) {
    items {
      seo {
        ...SeoMetaData
      }
      avatar {
        url
      }
    }
  }
}
    ${SeoMetaDataFragmentDoc}`;

export const useBlogPostAuthorSeoQuery = <
      TData = BlogPostAuthorSeoQuery,
      TError = unknown
    >(
      variables?: BlogPostAuthorSeoQueryVariables,
      options?: Omit<UseQueryOptions<BlogPostAuthorSeoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BlogPostAuthorSeoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BlogPostAuthorSeoQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['blogPostAuthorSeo'] : ['blogPostAuthorSeo', variables],
    queryFn: graphqlFetcher<BlogPostAuthorSeoQuery, BlogPostAuthorSeoQueryVariables>(BlogPostAuthorSeoDocument, variables),
    ...options
  }
    )};

useBlogPostAuthorSeoQuery.getKey = (variables?: BlogPostAuthorSeoQueryVariables) => variables === undefined ? ['blogPostAuthorSeo'] : ['blogPostAuthorSeo', variables];


useBlogPostAuthorSeoQuery.fetcher = (variables?: BlogPostAuthorSeoQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BlogPostAuthorSeoQuery, BlogPostAuthorSeoQueryVariables>(BlogPostAuthorSeoDocument, variables, options);
